import { render, staticRenderFns } from "./CubesIcon.vue?vue&type=template&id=213784f6&"
import script from "./CubesIcon.vue?vue&type=script&lang=js&"
export * from "./CubesIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports